import React from "react";

import "./ToastList.css";

export const ToastList: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="toast-list">{children}</div>;
